import StepPricing from './StepPricing';
import StepModel from '../../../model/configurator/StepModel';
import store from '@lib/store/configuration';

export default class StepTopArticleNumberPricing extends StepPricing {

    _stepClassName = 'configuration-editor-step-toparticlenumberpricing';

    configurationAPIServiceSuccess(response) {
        super.configurationAPIServiceSuccess(response);
        store.formModel.topArticleNumberPricing = response.data.topArticleNumberPricing;
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        this.setState({
            model: nextProps.model.topArticleNumberPricing
        })
    }

    renderImportFromExcelButton() {
        return <React.Fragment/>
    }

    static getStepModel(model) {
        return new StepModel('topArticleNumberPricing', model.topArticleNumberPricing)
    }
}